import api from '../../config/axios.js';
import moment from 'moment';
import 'moment/dist/locale/pt-br';
moment.locale('pt-br');

const state = {
    calendar: [],
    categories: [],
    subcategories: [],
    services: [],
    paymentMethods: [],
    allPaymentMethods: [],
    currentCalendar: null,
    currentUpdatePaymentMethod: null,
    currentDeletePaymentMethod: null,
    currentUpdateCategory: null,
}
const getters = {
    getCalendar: state => state.calendar,
    getCategories: state => state.categories,
    getSubcategories: state => state.subcategories,
    getServices: state => state.services,
    getPaymentMethods: state => state.paymentMethods,
    getAllPaymentMethods: state => state.allPaymentMethods,
    getCurrentCalendar: state => state.currentCalendar,
    getCurrentUpdatePaymentMethod: state => state.currentUpdatePaymentMethod,
    getCurrentDeletePaymentMethod: state => state.currentDeletePaymentMethod,
    getCurrentUpdateCategory: state => state.currentUpdateCategory,
}
const actions = {
    // ACRESCENTANDO NOVO EVENTO NO CALENDÁRIO A PARTIR DE WEBSOCKET
    async receiveCalendarByWebsocket({ commit, getters }, data){
        commit("receiveCalendarByWebsocket", data);
    },
    // BUSCANDO EVENTOS DO CALENDÁRIO
    async fetchCalendar({ commit, getters }, params){

        await api.axios.get('/api/calendar/list', {params}).catch(() => {
            return;
        }).then(response => {
            if(response && response.data){
                commit("fetchCalendar", response.data);
            }
        });

    },
    // BUSCANDO CATEGORIAS
    async fetchCategories({ commit }){

        await api.axios.get('/api/category/list').catch(() => {
            return;
        }).then(response => {
            if(response && response.data){
                commit("fetchCategories", response.data);
            }
        });

    },
    // BUSCANDO SERVICOS
    async fetchAllServices({ commit }, params){
        try {
            const response = await api.axios.get('/api/service/list/all', {params});
            const data = response?.data || [];
            commit("fetchServices", data);
            return data;
        } catch (error) {
            commit("fetchServices", []);
            return [];
        }

    },
    async fetchServices({ commit }, params){
        await api.axios.get('/api/service/list', {params}).catch(() => {
            return;
        }).then(response => {
            if(response && response.data){
                commit("fetchServices", response.data);
            }
        });

    },
    // BUSCANDO FORMAS DE PAGAMENTO
    async fetchPaymentMethods({ commit }){
        await api.axios.get('/api/payment-methods').catch(() => {
            return;
        }).then(response => {
            if(response && response.data){
                commit("fetchPaymentMethods", response.data);
            }
        });

    },
    async fetchAllPaymentMethods({ commit }){
        await api.axios.get('/api/all-payment-methods').catch(() => {
            return;
        }).then(response => {
            if(response && response.data){
                commit("fetchAllPaymentMethods", response.data);
            }
        });

    },
    // DEFININDO CATEGORIA ATUAL A SER ATUALIZADA
    setCurrentUpdateCategory({ commit }, category){
        commit("setCurrentUpdateCategory", category);
    },
    // CRIANDO AGENDAMENTO
    async createSchedule({ commit }, params){
        let url = "";

        if(params.block){
            url = '/api/ura/block/calendar';
        } else {
            url = '/api/ura/schedule/create';
        }

        try {
            const response = await api.axios.post(url, params);
            if(response && response.data){
                window.location.reload();
            }
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, status: error.response ? error.response.status : 500, error: error };
        }
    },
    async fetchSubcategories({ commit }, params = {}){
        try {
            const response = await api.axios.get('/api/subcategory/list', { params });
            const data = response?.data || [];
            commit("fetchSubcategories", data);
            return data;
        } catch (error) {
            commit("fetchSubcategories", []);
            return [];
        }
    },
    clearServices({ commit }){
        commit("fetchServices", []);
    },
    // ATUALIZANDO AGENDAMENTO
    async saveSchedule({ commit }, params){
        try {
            const response = await api.axios.post('/api/ura/schedule/update', params);
            if(response && response.data){
                window.location.reload();
            }
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, status: error.response ? error.response.status : 500, error: error };
        }
    },
    async excludeSchedule({ commit }, params){
        await api.axios.post('/api/ura/schedule/delete', params).catch(() => {
            return;
        }).then(response => {
            if(response && response.data){
                window.location.reload();
            }
        });

    },
    // SETANDO AGENDAMENTO ATUAL
    async setCurrentCalendar({ commit }, currentCalendar){
        commit("setCurrentCalendar", currentCalendar);
    },
    // SETANDO MÉTODO DE PAGAMENTO PARA ATUALIZAR
    async setCurrentUpdatePaymentMethod({ commit }, paymentMethod){
        commit("setCurrentUpdatePaymentMethod", paymentMethod);
    },
    // SETANDO MÉTODO DE PAGAMENTO PARA DELETAR
    async setCurrentDeletePaymentMethod({ commit }, paymentMethod){
        commit("setCurrentDeletePaymentMethod", paymentMethod);
    },
}

const mutations = {
    receiveCalendarByWebsocket: function(state, data){
        if (!data?.id) return;
        const existing = state.calendar.find(item => String(item.id) === String(data.id));
        const remaining = state.calendar.filter(item => String(item.id) !== String(data.id));
        state.calendar = data.status === 'CANCELED'
            ? remaining
            : [...remaining, { ...existing, ...data }];
    },
    fetchCalendar: function(state, data){
        state.calendar = data;
    },
    fetchCategories: function(state, data){
        state.categories = data;
    },
    fetchSubcategories: function(state, data){
        state.subcategories = data;
    },
    fetchServices: function(state, data){
        state.services = data;
    },
    fetchPaymentMethods: function(state, data){
        state.paymentMethods = data;
    },
    fetchAllPaymentMethods: function(state, data){
        state.allPaymentMethods = data;
    },
    setCurrentCalendar: function(state, data){
        state.currentCalendar = data;
    },
    setCurrentUpdatePaymentMethod: function(state, data){
        state.currentUpdatePaymentMethod = data;
    },
    setCurrentDeletePaymentMethod: function(state, data){
        state.currentDeletePaymentMethod = data;
    },
    setCurrentUpdateCategory: function(state, data){
        state.currentUpdateCategory = data;
    },
    // appendNewMessageChat: function(state, data){
    //     data.date_formatted = data.created_at
    //                 ? moment(data.created_at).format("HH:mm:ss DD/MM/YY")
    //                 : null;

    //     const newData = [data];
    //     state.messagesChat = [...newData, ...state.messagesChat];
    // }
}
export default {
    state,
    getters,
    actions,
    mutations
}
